<div class="container">
    <div class="logo">
        <img src="assets/img/my-remedi-logo-login.png">
    </div>
    <div>
        <h1>
            Access Denied.
        </h1>
        <div>
        The location/computer you are using is not approved for access to the selected facility per an IP restriction agreement.
        </div>
        <div>
        Please contact your facility's MyRemedi administrator for more information.
        </div>
    </div>
</div>